<template>
  <Pie :data="chartData" :options="chartOptions" />
</template>
<script setup>
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";

import { computed } from "vue";
import { Pie } from "vue-chartjs";

ChartJS.register(ArcElement, Tooltip, Legend);

const props = defineProps({
  labels: {
    type: Array,
    required: true,
  },
  data: {
    type: Array,
    required: true,
  },
  colors: {
    type: Array,
    required: true,
  },
});

function getFgColor() {
  return (
    getComputedStyle(document.documentElement)
      .getPropertyValue("--fg1")
      .trim() || "#222"
  );
}

const chartData = computed(() => ({
  labels: props.labels,
  datasets: [
    {
      backgroundColor: props.colors,
      data: props.data,
      borderWidth: 1,
      borderColor: getFgColor(),
    },
  ],
}));

const chartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      display: true,
      position: "top",
      align: "center",
      labels: {
        color: getFgColor(),
      },
    },
    tooltip: {
      callbacks: {
        label: function (context) {
          return ` $${context.parsed}`;
        },
      },
    },
  },
};
</script>
